<template>
    <loading v-if="isLoading"></loading>
    <transition v-else name="fade">
        <section class="settings">
            <header class="overlay__header">
                <aside>
                    <a :href="channel.url">{{ channel.name }}</a>
                    <icon type="chevron-right" color="white" size="12" />
                    <span>Channel Settings</span>
                </aside>
            </header>
            <section class="panel">
                <aside class="panel__sidebar">
                    <nav data-locator="navigation" class="panel-navigation">
                        <template v-for="(route, index) in $router.options.routes">
                            <router-link
                                    :key="index"
                                    v-if="route.show !== false"
                                    :to="{ name: route.name, params: { channel: channel.slug } }"
                                    :exact="route.children === undefined"
                                    active-class="active"
                                    class="panel-navigation__item"
                                    role="tab">
                                {{ route.title }}
                            </router-link>
                        </template>
                    </nav>
                </aside>
                <div class="panel__content">
                    <portal-target slim name="panel_content"></portal-target>
                    <transition name="fade" mode="out-in" :duration="0">
                        <router-view></router-view>
                    </transition>
                </div>
            </section>
        </section>
    </transition>
</template>
<script>
/* global app */
import { mapState } from 'vuex'
import EmptyRouteView from '../Global/EmptyRouteView'
import General from './Settings/General'
import PeopleIndex from './Settings/People/Index'
import PeopleOptions from './Settings/People/Options'
import PeopleAdd from './Settings/People/Add'
import PeopleInvite from './Settings/People/Invite'
import Notifications from './Settings/Notifications'
import Integrations from './Settings/Integrations'
import Archive from './Settings/Archive'
import Loading from '../Global/Loading'
import Icon from '../Global/Icon'
import VueRouter from 'vue-router'

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/channel/:channel/settings', component: General, title: 'General', name: 'general' },
        {
            path: '/channel/:channel/settings/people',
            component: EmptyRouteView,
            title: 'People',
            name: 'people.index',
            children: [
                { path: '', name: 'people.index', title: 'People', component: PeopleIndex },
                { path: 'options', name: 'people.options', component: PeopleOptions },
                { path: 'add', name: 'people.add', component: PeopleAdd },
                { path: 'invite', name: 'people.invite', component: PeopleInvite }
            ]
        },
        { path: '/channel/:channel/settings/notifications', name: 'notifications', component: Notifications, title: 'Notifications' },
        { path: '/channel/:channel/settings/integrations', name: 'integrations', component: Integrations, title: 'Integrations', show: app.currentUser.is_not_guest },
        { path: '/channel/:channel/settings/archive-jobs', name: 'archive-jobs', component: Archive, title: 'Archive' }
    ]
})

export default {
    name: 'ChannelSettings',

    router,

    props: {
        channelId: {
            required: true,
            type: Number
        }
    },

    data () {
        return {
            isLoading: true
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('channel/fetchChannel', this.channelId),
            this.$store.dispatch('channel/fetchMembers', this.channelId)
        ]).then(() => {
            this.isLoading = false
            this.$store.dispatch('tenant/fetchUsers')
            this.$store.dispatch('channel/fetchArchive')
            this.$store.dispatch('channel/fetchCurrentChannelMember')
        })
    },

    computed: {
        ...mapState('users', { currentUser: 'current' }),
        ...mapState('channel', ['channel'])
    },

    components: {
        Loading,
        Icon
    }
}
</script>
